export type EventHandler = (e: { type: string; data: any }) => void;
export type Unsubscribe = {
    unsubscribe: () => void;
};

export class Evented {
    private eventHandlers: Record<string, EventHandler[]> = {};

    on(eventName: string, handler: EventHandler): Unsubscribe {
        this.eventHandlers[eventName] ??= [];
        this.eventHandlers[eventName].push(handler);
        return {
            unsubscribe: () => this.off(eventName, handler)
        };
    }

    off(eventName: string, handler: EventHandler): this {
        this.eventHandlers[eventName] = this.eventHandlers[eventName].filter((x) => x !== handler);
        return this;
    }

    fire(eventName: string, data: any) {
        this.eventHandlers[eventName]?.forEach((x) =>
            x({
                type: eventName,
                data
            })
        );
    }

    finalize() {
        this.eventHandlers = {};
    }
}
